import React, { Component } from 'react'
import constants from '../constants'
import Store from '../store'
import LocalsMenu from "./localsMenu.json"
import i18n from "../utils/i18n"
import CircledButton from './circled-button'
import Actions from '../actions'
import { gsap } from "gsap"

class LookbookInformation extends Component {
  constructor(props) {
    super(props)
    this.parent = React.createRef()
    this.desktopDescription = React.createRef()
    this.mobileDescription = React.createRef()
    this.state = {
      slideIndex: 0,
      lines: undefined,
      lineHeight: 0
    }
  }
  componentDidMount() {
    gsap.set(this.parent.current, { y: `130%`, opacity: 0 })
    Store.on(constants.CHANGE_SLIDE, this.onChangeSlide)
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.transition === `in`) {
      gsap.to(this.parent.current, { y: `0%`, opacity: 1, delay: 0.6, duration: 0.8, ease: "expo.out" })
    } else {
      gsap.to(this.parent.current, { y: `130%`, opacity: 0, duration: 0.4, ease: "expo.out" })
    }
  }
  componentWillUnmount() {
    Store.off(constants.CHANGE_SLIDE, this.onChangeSlide)
    Store.productLink = undefined
  }
  getCode = () => {
    if (this.props.lang === `fr`) return `fr_fr`
    else if (this.props.lang === `it`) return `it_it`
    else if (this.props.lang === `pt`) return `pt_pt`
    else if (this.props.lang === `tr`) return `tr_tr`
    else return `en_gb`
  }
  getStoryLink = () => {
    if (this.props.lang === `fr`) return `https://www2.hm.com/fr_fr/free-form-campaigns/hm-innovation-colour-story.html`
    else if (this.props.lang === `it`) return `https://www2.hm.com/it_it/free-form-campaigns/hm-innovation-colour-story.html`
    else if (this.props.lang === `pt`) return `https://www2.hm.com/pt_pt/free-form-campaigns/hm-innovation-colour-story.html`
    else if (this.props.lang === `tr`) return `https://www2.hm.com/tr_tr/free-form-campaigns/hm-innovation-colour-story.html`
    else return `https://www2.hm.com/en_gb/free-form-campaigns/hm-innovation-colour-story.html`
  }
  onChangeSlide = (id) => {
    this.setState({ slideIndex: id })
    const local = this.props.locals[this.props.lang]
    const currentLook = local[`${this.props.prefix}-${id}`]
    const productNumber = currentLook.href
    if (productNumber && productNumber.length > 3) {
      Store.productLink = `https://www2.hm.com/${this.getCode()}/productpage.${productNumber}.html`
      // Store.productLink = this.getStoryLink()
    } else {
      Store.productLink = undefined
    }
  }
  onTrigger = () => {
    setTimeout(Actions.closeLookbook)
  }
  render() {
    const local = this.props.locals[this.props.lang]
    const currentLook = local[`${this.props.prefix}-${this.state.slideIndex}`]
    const buttonHref = currentLook.href.length > 2 ? `https://www2.hm.com/${this.getCode()}/productpage.${currentLook.href}.html` : undefined
    // const buttonHref = currentLook.href.length > 2 ? this.getStoryLink() : undefined
    return (
      <div ref={this.parent} className={`${this.props.className} fixed bottom-0 lg:bottom-8 left-0 lg:left-8 z-20 w-full lg:w-5/12 p-5 lg:p-0`}>
        <div className={`${constants.paragraph} hidden lg:block bg-white rounded-4xl px-6 py-5`}>
          <div className={`font-sans uppercase`}>{currentLook.title}</div>
          <div ref={this.desktopDescription} className={`font-sans text-lg`} dangerouslySetInnerHTML={{__html: currentLook.description}}/>
        </div>
        <div className={`lg:hidden bg-white rounded-4xl`}>
          <div className={`px-6 py-5 ${constants.heading} relative`}>
            <div className={`uppercase`}>{currentLook.title}</div>
            <div ref={this.mobileDescription} className={`mt-1 mb-2 text-sm`} dangerouslySetInnerHTML={{__html: currentLook.description}}/>
            { buttonHref && <a className={`border-b border-black`} target={`_blank`} href={buttonHref}>{i18n(LocalsMenu, `title-order`, this.props.lang)}</a> }
            <CircledButton onClick={this.onTrigger} state={`close`} className={`bg-black text-white absolute bottom-3 right-3 w-10 h-10 lg:w-16 lg:h-16`} />
          </div>
        </div>
      </div>
    )
  }
}

export default LookbookInformation
